import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "cross",
  "use": "cross-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol viewBox=\"0 0 512 512\" id=\"cross\"><path d=\"M507.331 411.33l-.006-.005L352.003 256l155.322-155.325.006-.005a15.881 15.881 0 0 0 3.656-5.708c2.123-5.688.912-12.341-3.662-16.915L433.952 4.674c-4.574-4.573-11.225-5.783-16.914-3.66a15.913 15.913 0 0 0-5.709 3.655c0 .002-.002.003-.004.005L256.001 160 100.677 4.675l-.005-.005a15.897 15.897 0 0 0-5.707-3.655c-5.69-2.124-12.341-.913-16.915 3.66L4.676 78.049C.102 82.623-1.108 89.275 1.015 94.963a15.908 15.908 0 0 0 3.656 5.708l.005.005L160.001 256 4.676 411.326l-.004.005a15.93 15.93 0 0 0-3.657 5.707c-2.124 5.688-.913 12.341 3.661 16.915l73.374 73.373c4.575 4.574 11.226 5.784 16.915 3.661a15.917 15.917 0 0 0 5.708-3.656l.005-.005 155.324-155.325 155.324 155.325.006.004a15.91 15.91 0 0 0 5.707 3.657c5.689 2.123 12.342.913 16.914-3.661l73.373-73.374c4.574-4.574 5.785-11.227 3.662-16.915a15.902 15.902 0 0 0-3.657-5.707z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/cross.svg
// module id = k9GA
// module chunks = 1